'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

exports.default = extractJSON;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** Decode base-64 encoded string into JSON, then to native object */
function extractJSON(value) {
  if (typeof value !== 'string' || !value.length) {
    return {};
  }

  if ((typeof window === 'undefined' ? 'undefined' : (0, _typeof3.default)(window)) === 'object' && typeof window.atob !== 'function') {
    throw new Error('This browser does not support base-64 decoding: atob');
  }

  var decoded = window.atob(value);

  return JSON.parse(decoded);
}
//# sourceMappingURL=extractJSON.js.map